import React, { Component } from 'react';
import FormInput from '../../../components/formInput/FormInput';
import * as Styles from './Styles';
import * as FormManager from '../../../reducers/ui/form';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../../core/Store';
import {
	NumericalOnlyStringGuard,
	PostalCodeStringGuard,
} from '../../../core/guards';
import HoverPopover, { POSITION } from '@react_components/hover_popover';
import Switch from '../../../components/switch/Switch';

type State = {};

class FormComponent extends Component<PropsFromRedux, State> {
	state: State = {};

	render() {
		return (
			<>
				<Styles.Background>
					<img
						src="/backgrounds/bg_ratownik.png"
						alt="dekor ratownik"
					/>
					<Styles.FormContainer id="form-stage2-form">
						{this.props.error && (
							<HoverPopover
								content={<span>{this.props.error}</span>}
								position={POSITION.TOP}
							>
								<Styles.StyledSvgInfo />
							</HoverPopover>
						)}
						<Styles.FormContainerTopFont>
							Dane Finansującego Składkę i Ubezpieczonego
						</Styles.FormContainerTopFont>
						<Styles.FormContainerBottomFont>
							pola oznaczone gwiazdką (*) są obowiązkowe
						</Styles.FormContainerBottomFont>
						<Styles.FormInnerContainer>
							<Styles.FormRow className="personal">
								<FormInput
									label="IMIĘ*"
									onChange={(value) =>
										FormManager.setPersonalInfoField(
											'firstName',
											value
										)
									}
									placeholder="imię"
									value={
										this.props.personalInfo.firstName || ''
									}
									error={
										this.props.personalInfoErrors.firstName
									}
								/>
								<FormInput
									label="NAZWISKO*"
									onChange={(value) =>
										FormManager.setPersonalInfoField(
											'lastName',
											value
										)
									}
									placeholder="nazwisko"
									value={
										this.props.personalInfo.lastName || ''
									}
									error={
										this.props.personalInfoErrors.lastName
									}
								/>
								<FormInput
									label="PESEL*"
									onChange={(value) =>
										FormManager.setPersonalInfoField(
											'pesel',
											NumericalOnlyStringGuard(value)
										)
									}
									placeholder="nr PESEL"
									value={this.props.personalInfo.pesel || ''}
									error={this.props.personalInfoErrors.pesel}
									maxLength={11}
								/>
							</Styles.FormRow>
							<Styles.RowDivider />
							<Styles.FormRow className="business-switch">
								<Styles.HasBusinessContainer>
									<p>
										czy prowadzisz działalność gospodarczą?
									</p>
									<span>NIE</span>
									<Switch
										isActive={this.props.hasBusiness}
										onClick={() =>
											this.props.setHasBusiness(
												!this.props.hasBusiness
											)
										}
									/>
									<span>TAK</span>
								</Styles.HasBusinessContainer>
							</Styles.FormRow>
							{this.props.hasBusiness && (
								<Styles.FormRow className="business">
									<FormInput
										label="NAZWA DZIAŁALNOŚCI*"
										onChange={(value) =>
											FormManager.setPersonalInfoField(
												'businessName',
												value
											)
										}
										placeholder="nazwa działalności"
										value={
											this.props.personalInfo
												.businessName || ''
										}
										error={
											this.props.personalInfoErrors
												.businessName
										}
									/>
									<FormInput
										label="NIP*"
										onChange={(value) =>
											FormManager.setPersonalInfoField(
												'nip',
												NumericalOnlyStringGuard(value)
											)
										}
										placeholder="numer NIP"
										value={
											this.props.personalInfo.nip || ''
										}
										error={
											this.props.personalInfoErrors.nip
										}
										maxLength={10}
									/>
								</Styles.FormRow>
							)}
							<Styles.RowHeadingFont>
								Adres zamieszkania
							</Styles.RowHeadingFont>
							<Styles.FormRow className="adress">
								<FormInput
									label="ULICA"
									onChange={(value) =>
										FormManager.setPersonalInfoAdressField(
											'street',
											value
										)
									}
									placeholder="ulica"
									value={
										this.props.personalInfo
											.residentalAddress?.street || ''
									}
									error={
										this.props.personalInfoRAdressErrors
											.street
									}
								/>
								<FormInput
									label="NR DOMU*"
									onChange={(value) =>
										FormManager.setPersonalInfoAdressField(
											'houseNo',
											value
										)
									}
									placeholder="numer"
									value={
										this.props.personalInfo
											.residentalAddress?.houseNo || ''
									}
									error={
										this.props.personalInfoRAdressErrors
											.houseNo
									}
								/>
								<FormInput
									label="LOKAL"
									onChange={(value) =>
										FormManager.setPersonalInfoAdressField(
											'appartmentNo',
											value
										)
									}
									placeholder="lokal"
									value={
										this.props.personalInfo
											.residentalAddress?.appartmentNo ||
										''
									}
									error={
										this.props.personalInfoRAdressErrors
											.appartmentNo
									}
								/>
								<FormInput
									label="KOD POCZTOWY*"
									onChange={(value) =>
										FormManager.setPersonalInfoAdressField(
											'postalCode',
											PostalCodeStringGuard(value)
										)
									}
									placeholder="00-000"
									value={
										this.props.personalInfo
											.residentalAddress?.postalCode || ''
									}
									error={
										this.props.personalInfoRAdressErrors
											.postalCode
									}
								/>
								<FormInput
									label="MIEJSCOWOŚĆ*"
									onChange={(value) =>
										FormManager.setPersonalInfoAdressField(
											'city',
											value
										)
									}
									placeholder="miejscowość"
									value={
										this.props.personalInfo
											.residentalAddress?.city || ''
									}
									error={
										this.props.personalInfoRAdressErrors
											.city
									}
								/>
							</Styles.FormRow>
							<Styles.RowDivider />
							<Styles.RowHeadingFont>
								Dane kontaktowe
							</Styles.RowHeadingFont>
							<Styles.FormRow className="contact">
								<FormInput
									label="E-MAIL*"
									onChange={(value) => {}}
									placeholder="adres email"
									value={this.props.personalInfo.email || ''}
									disabled
								/>
								<FormInput
									label="TELEFON KOMÓRKOWY*"
									onChange={(value) =>
										FormManager.setPersonalInfoField(
											'phone',
											NumericalOnlyStringGuard(value)
										)
									}
									placeholder="nr tel"
									value={this.props.personalInfo.phone || ''}
									error={this.props.personalInfoErrors.phone}
									maxLength={9}
								/>
							</Styles.FormRow>
						</Styles.FormInnerContainer>
					</Styles.FormContainer>
				</Styles.Background>
			</>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		personalInfo: FormManager.Selectors.getPersonalInfo(state),
		personalInfoErrors: FormManager.Selectors.getPersonalInfoErrors(state),
		personalInfoRAdressErrors:
			FormManager.Selectors.getPersonalInfoRAdressErrors(state),
		error: FormManager.Selectors.getFormError(state),
		hasBusiness: FormManager.Selectors.getHasBusiness(state),
	}),
	(dispatch) => ({
		setHasBusiness: (payload: boolean) =>
			dispatch(FormManager.Actions.setHasBusiness(payload)),
	})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Form = connector(FormComponent);
export default Form;
